/* Pages villes Sauvdefib : « Ouvert jusqu'à… », cartes Leaflet, filtres GéoDAE,
   galerie, vidéo en façade légère et filtre des zones d'intervention.
   Tout le contenu est déjà dans le HTML : ce script n'ajoute que l'interaction. */
(function () {
  'use strict';

  /* Horaires : lun-ven 7h-19h30, sam 7h-17h, dim fermé, à l'heure de Paris. */
  var PLAGES = { 1: ['07:00', '19:30'], 2: ['07:00', '19:30'], 3: ['07:00', '19:30'], 4: ['07:00', '19:30'], 5: ['07:00', '19:30'], 6: ['07:00', '17:00'] };
  var heure = function (hhmm) { var p = hhmm.split(':'); return +p[0] + 'h' + (p[1] !== '00' ? p[1] : ''); };
  function etat() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      var v = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
      var jour = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(v('weekday'));
      var maintenant = v('hour') + ':' + v('minute');
      var p = PLAGES[jour];
      if (p && maintenant >= p[0] && maintenant < p[1]) return { o: 1, t: "Ouvert jusqu'à " + heure(p[1]) };
      return { o: 0, t: 'Fermé actuellement' };
    } catch (e) { return null; }
  }
  function majEtat() {
    var e = etat();
    if (!e) return;
    document.querySelectorAll('[data-sdv-etat]').forEach(function (el) { el.textContent = e.t; el.setAttribute('data-ouvert', e.o); });
  }

  /* Leaflet, chargé seulement quand une carte approche de l'écran. */
  var leaflet = null;
  function chargeLeaflet() {
    if (leaflet) return leaflet;
    leaflet = new Promise(function (ok, ko) {
      if (window.L) return ok(window.L);
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(css);
      var s = document.createElement('script');
      s.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      s.onload = function () { ok(window.L); };
      s.onerror = ko;
      document.head.appendChild(s);
    });
    return leaflet;
  }
  function quandVisible(el, fn) {
    if (!('IntersectionObserver' in window)) return fn();
    var io = new IntersectionObserver(function (entrees) {
      if (entrees.some(function (e) { return e.isIntersecting; })) { io.disconnect(); fn(); }
    }, { rootMargin: '400px' });
    io.observe(el);
  }
  var echappe = function (v) { return String(v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  function fond(L, map) {
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' }).addTo(map);
    if ('ResizeObserver' in window) new ResizeObserver(function () { map.invalidateSize(); }).observe(map.getContainer());
  }

  /* Carte de l'établissement : le centre et les centres voisins du département. */
  function carteEtablissement(el) {
    quandVisible(el, function () {
      chargeLeaflet().then(function (L) {
        var lat = +el.dataset.lat, lon = +el.dataset.lon;
        var map = L.map(el, { scrollWheelZoom: false }).setView([lat, lon], 13);
        fond(L, map);
        var pts = [[lat, lon]];
        var voisins = [];
        try { voisins = JSON.parse(el.dataset.voisins || '[]'); } catch (e) {}
        voisins.forEach(function (v) {
          pts.push([v[2], v[3]]);
          L.circleMarker([v[2], v[3]], { radius: 7, color: '#fff', weight: 2, fillColor: '#2c5282', fillOpacity: 1 })
            .bindTooltip('<strong>Sauvdefib ' + echappe(v[0]) + '</strong><br>' + v[4] + ' km', { direction: 'top' })
            .on('click', function () { window.location.href = '/pages/' + v[1]; })
            .addTo(map);
        });
        L.circleMarker([lat, lon], { radius: 11, color: '#fff', weight: 3, fillColor: '#db1315', fillOpacity: 1 })
          .bindTooltip('<strong>' + echappe(el.dataset.nom || 'Sauvdefib') + '</strong>', { direction: 'top', permanent: false })
          .addTo(map);
        if (pts.length > 1) map.fitBounds(L.latLngBounds(pts).pad(0.15), { maxZoom: 12 });
      });
    });
  }

  /* Défibrillateurs de la commune, lus en direct sur GéoDAE (data.gouv.fr) avec
     les règles des pages villes de ventedefibrillateur (lib/geodae.ts) : lignes du
     code postal, de la commune, validées, en fonctionnement, hors mobiles et
     doublons, situées dans le contour officiel de la commune ; un site regroupe
     les appareils d'un même lieu. Puis filtres, carte et liste liées. */
  var GEODAE = 'https://tabular-api.data.gouv.fr/api/resources/edb6a9e1-2f16-4bbf-99e7-c3eb6b90794c/data/';
  var COLONNES = 'gid,c_nom,c_adr_num,c_adr_voie,c_com_nom,c_lat_coor1,c_long_coor1,c_acc,c_acc_complt,c_acc_lib,c_dispo_horaires,c_etat_fonct,c_etat_valid,c_doublon,c_dae_mobile';
  var MAX_SITES = 200;
  function normaliser(s) {
    return String(s || '').replace(/œ/gi, 'oe').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/\b(st|ste)\b/g, function (m) { return m === 'st' ? 'saint' : 'sainte'; }).replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function casse(s) { return /[a-zà-ÿ]/.test(s) ? s : s.toLowerCase().replace(/(^|[\s'’(-])([a-zà-ÿ])/g, function (_, a, b) { return a + b.toUpperCase(); }); }
  function propre(s) { var v = s && String(s).trim(); return v ? v : null; }
  function distanceKm(a, b) {
    var rad = function (d) { return d * Math.PI / 180; };
    var h = Math.pow(Math.sin(rad(b[0] - a[0]) / 2), 2) + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.pow(Math.sin(rad(b[1] - a[1]) / 2), 2);
    return 6371 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  }
  function dansContour(polys, lat, lon) {
    return polys.some(function (anneaux) {
      var dedans = false;
      anneaux.forEach(function (an) {
        for (var i = 0, j = an.length - 1; i < an.length; j = i++) {
          var xi = an[i][0], yi = an[i][1], xj = an[j][0], yj = an[j][1];
          if ((yi > lat) !== (yj > lat) && lon < (xj - xi) * (lat - yi) / (yj - yi) + xi) dedans = !dedans;
        }
      });
      return dedans;
    });
  }
  function json(url) { return fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function lignesGeoDae(cp) {
    var toutes = [];
    function page(n) {
      return json(GEODAE + '?c_com_cp__exact=' + cp + '&page=' + n + '&page_size=200&columns=' + COLONNES).then(function (j) {
        toutes = toutes.concat(j.data);
        if (toutes.length >= j.meta.total || j.data.length < 200 || n >= 8) return toutes;
        return page(n + 1);
      });
    }
    return page(1);
  }
  function contour(cp, code, ville, arr) {
    var url = 'https://geo.api.gouv.fr/communes?codePostal=' + cp + '&fields=nom,code,contour' + (arr ? '&type=arrondissement-municipal' : '');
    return json(url).then(function (liste) {
      var cible = normaliser(ville);
      var c = liste.filter(function (x) { return x.code === code; })[0] || liste.filter(function (x) { return normaliser(x.nom) === cible; })[0] || (liste.length === 1 ? liste[0] : null);
      var ct = c && c.contour;
      if (!ct) return null;
      return ct.type === 'Polygon' ? [ct.coordinates] : ct.type === 'MultiPolygon' ? ct.coordinates : null;
    }).catch(function () { return null; });
  }
  function sitesDae(d) {
    var depuis = [+d.lat, +d.lon];
    return Promise.all([lignesGeoDae(d.cp), contour(d.cp, d.u, d.ville, d.arr === '1')]).then(function (r) {
      var lignes = r[0], polys = r[1];
      var cible = normaliser(d.ville);
      var deLaCommune = lignes.filter(function (l) { var n = normaliser(l.c_com_nom); return n === cible || n.indexOf(cible + ' ') === 0; });
      var retenues = (deLaCommune.length ? deLaCommune : lignes).filter(function (l) {
        return l.c_doublon !== 't' && l.c_dae_mobile !== 't' && l.c_etat_valid === 'validées' && l.c_etat_fonct === 'En fonctionnement' &&
          l.c_lat_coor1 != null && l.c_long_coor1 != null &&
          (polys ? dansContour(polys, l.c_lat_coor1, l.c_long_coor1) : (String(d.cp).indexOf('97') === 0 || distanceKm(depuis, [l.c_lat_coor1, l.c_long_coor1]) <= 40));
      });
      var parSite = {}, ordre = [];
      retenues.forEach(function (l) {
        var lat = l.c_lat_coor1, lon = l.c_long_coor1, nomBrut = propre(l.c_nom);
        var cle = lat.toFixed(4) + '|' + lon.toFixed(4) + '|' + normaliser(nomBrut || '');
        if (parSite[cle]) { parSite[cle].n += 1; return; }
        var voie = (propre(l.c_adr_voie) || '').split(',')[0];
        var h = l.c_dispo_horaires;
        parSite[cle] = {
          nom: nomBrut && /[a-zà-ÿ]/i.test(nomBrut) && !/^[a-z]{0,5}[-_ ]?\d{4,}$/i.test(nomBrut) ? casse(nomBrut) : 'Défibrillateur',
          adr: [propre(l.c_adr_num), casse(voie)].filter(Boolean).join(' '),
          lat: lat, lon: lon, km: distanceKm(depuis, [lat, lon]),
          f: (l.c_acc === 'Extérieur' ? 1 : 0) | (!!h && /^(24\/7|mo-su 00:00-(23:59|24:00))$/i.test(String(h).trim()) ? 2 : 0) | (l.c_acc_lib === 't' ? 4 : 0),
          n: 1
        };
        ordre.push(parSite[cle]);
      });
      return ordre.sort(function (a, b) { return a.km - b.km; });
    });
  }
  var km = function (x) { return x.toFixed(1).replace('.', ',') + ' km'; };
  function ligneHtml(s, i) {
    var e = function (t, v) { return '<span class="sdv-eti' + (v ? ' sdv-eti--v' : '') + '">' + t + '</span>'; };
    return '<li data-i="' + i + '" data-f="' + s.f + '"><span class="n">' + echappe(s.nom) + '</span><span class="d">' + km(s.km) + '</span>' +
      (s.adr ? '<span class="a">' + echappe(s.adr) + '</span>' : '') +
      '<span class="t">' + ((s.f & 1) ? e('Extérieur', 1) : e('Intérieur')) + ((s.f & 2) ? e('24 h/24', 1) : '') + ((s.f & 4) ? e('Accès libre') : '') +
      (s.n > 1 ? e(s.n + ' appareils') : '') +
      '<a class="i" href="https://www.google.com/maps/dir/?api=1&amp;destination=' + s.lat + ',' + s.lon + '" target="_blank" rel="noopener">Itinéraire →</a></span></li>';
  }

  function blocDae(bloc) {
    var d = bloc.dataset;
    var liste = bloc.querySelector('.sdv-liste');
    var filtres = bloc.querySelectorAll('.sdv-filtre');
    var boite = bloc.querySelector('[data-sdv-dae-map]');
    var note = bloc.querySelector('[data-sdv-dae-note]');
    var sites = [], lignes = [], marqueurs = {}, actif = null, masque = 0;
    var COUL = { ext: '#15803d', int: '#64748b', actif: '#db1315' };
    var garde = function (s) { return masque === 0 || (s.f & masque) === masque; };

    function style() {
      lignes.forEach(function (li, i) {
        var s = sites[i], ok = garde(s);
        li.hidden = !ok;
        var m = marqueurs[i];
        if (!m) return;
        var estActif = actif === i;
        m.setStyle({ fillColor: estActif ? COUL.actif : (s.f & 1) ? COUL.ext : COUL.int, fillOpacity: ok ? 0.95 : 0.12, opacity: ok ? 1 : 0.2 });
        if (estActif) { m.bringToFront(); m.openTooltip(); }
      });
    }
    function active(i, defile) {
      actif = i;
      lignes.forEach(function (li, j) { li.classList.toggle('sdv-actif', j === i); });
      if (defile && lignes[i]) liste.scrollTop = lignes[i].offsetTop - liste.clientHeight / 3;
      style();
    }
    filtres.forEach(function (b) {
      b.addEventListener('click', function () {
        masque = +b.dataset.m;
        filtres.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        style();
      });
    });

    quandVisible(bloc, function () {
      var carte = chargeLeaflet().then(function (L) {
        var lat = +d.lat, lon = +d.lon;
        var map = L.map(boite, { scrollWheelZoom: true, minZoom: 9, maxZoom: 18, preferCanvas: true }).setView([lat, lon], 13);
        fond(L, map);
        [1, 3, 5].forEach(function (r) {
          L.circle([lat, lon], { radius: r * 1000, color: '#94a3b8', weight: 1, dashArray: '4 4', fill: false, interactive: false }).addTo(map);
        });
        L.circleMarker([lat, lon], { radius: 10, color: '#fff', weight: 2.5, fillColor: '#1c3557', fillOpacity: 1 })
          .bindTooltip('<strong>Sauvdefib - Vente | Installation Défibrillateurs</strong>', { direction: 'top' }).addTo(map);
        return { L: L, map: map };
      });
      Promise.all([sitesDae(d), carte]).then(function (r) {
        var tous = r[0], L = r[1].L, map = r[1].map;
        sites = tous.slice(0, MAX_SITES);
        liste.innerHTML = sites.length ? sites.map(ligneHtml).join('') : '<li><span class="n">Aucun défibrillateur déclaré n\'a pu être localisé sur la commune.</span></li>';
        lignes = sites.length ? Array.prototype.slice.call(liste.querySelectorAll('li')) : [];
        if (note && tous.length > sites.length) note.textContent = 'Les ' + sites.length + ' sites les plus proches de notre centre sont listés, sur ' + tous.length + ' sites équipés. ';
        lignes.forEach(function (li, i) { li.addEventListener('mouseenter', function () { active(i, false); }); });
        var rendu = L.canvas({ padding: 0.5, tolerance: 6 });
        var proches = [[+d.lat, +d.lon]];
        sites.forEach(function (s, i) {
          if (s.km <= 3.5) proches.push([s.lat, s.lon]);
          marqueurs[i] = L.circleMarker([s.lat, s.lon], { renderer: rendu, radius: s.n > 1 ? 7 : 5.5, color: '#fff', weight: 1.5, fillColor: (s.f & 1) ? COUL.ext : COUL.int, fillOpacity: 0.95 })
            .bindTooltip('<strong>' + echappe(s.nom) + '</strong><br>' + echappe(s.adr) + ' · ' + km(s.km), { direction: 'top' })
            .on('click', function () { active(i, true); })
            .addTo(map);
        });
        if (proches.length > 1) map.fitBounds(L.latLngBounds(proches).pad(0.08), { maxZoom: 15 });
        style();
      }).catch(function () {
        liste.innerHTML = '<li><span class="n">La base GéoDAE ne répond pas pour le moment.</span><span class="a">Consultez la carte nationale sur <a href="https://geodae.atlasante.fr" target="_blank" rel="noopener">geodae.atlasante.fr</a>.</span></li>';
      });
    });
  }

  /* Galerie : les flèches avancent d'un écran. */
  function galerie(sec) {
    var piste = sec.querySelector('.sdv-piste');
    sec.querySelectorAll('[data-sens]').forEach(function (b) {
      b.addEventListener('click', function () { piste.scrollBy({ left: +b.dataset.sens * piste.clientWidth * 0.85, behavior: 'smooth' }); });
    });
  }

  /* Vidéo : miniature, puis lecteur YouTube au clic. */
  function video(b) {
    b.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + b.dataset.id + '?autoplay=1&rel=0';
      f.title = b.getAttribute('aria-label') || 'Vidéo';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      f.allowFullscreen = true;
      b.parentNode.replaceChild(f, b);
    });
  }

  /* Zones : filtre par tranche de 10 km, toutes les villes restent dans le HTML. */
  function zones(sec) {
    var puces = sec.querySelectorAll('.sdv-filtre[data-t]');
    var tranches = sec.querySelectorAll('.sdv-tranche');
    puces.forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.dataset.t;
        puces.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        tranches.forEach(function (tr) { tr.setAttribute('data-off', t === 'tout' || tr.dataset.t === t ? '0' : '1'); });
      });
    });
  }


  /* Annuaire : recherche (ouvre les départements trouvés) et carte de tous les centres. */
  function annuaire(sec) {
    var q = sec.querySelector('[data-sdv-q]');
    var compte = sec.querySelector('[data-sdv-compte]');
    var vide = sec.querySelector('[data-sdv-vide]');
    var deps = Array.prototype.slice.call(sec.querySelectorAll('.sdv-dep'));
    var total = sec.querySelectorAll('.sdv-annu-liste li').length;
    var sansAccent = function (v) { return String(v).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };
    q.addEventListener('input', function () {
      var t = sansAccent(q.value.trim());
      var n = 0;
      deps.forEach(function (d) {
        var k = 0;
        d.querySelectorAll('li').forEach(function (li) {
          var ok = !t || sansAccent(li.dataset.q).indexOf(t) >= 0 || d.dataset.dep === t;
          li.hidden = !ok;
          if (ok) k++;
        });
        d.hidden = k === 0;
        d.open = !!t && k > 0;
        n += k;
      });
      compte.textContent = t ? n + ' centre' + (n > 1 ? 's' : '') + ' sur ' + total + ' pour cette recherche.' : total + ' centres, classés par département.';
      vide.hidden = n > 0;
    });
  }
  function carteAnnuaire(el) {
    quandVisible(el, function () {
      chargeLeaflet().then(function (L) {
        var map = L.map(el, { scrollWheelZoom: false }).setView([46.6, 2.4], 6);
        fond(L, map);
        var rendu = L.canvas({ padding: 0.5 });
        document.querySelectorAll('.sdv-annu-liste li').forEach(function (li) {
          var a = li.querySelector('a');
          L.circleMarker([+li.dataset.lat, +li.dataset.lon], { renderer: rendu, radius: 5, color: '#fff', weight: 1, fillColor: '#db1315', fillOpacity: 0.9 })
            .bindTooltip(echappe(a.querySelector('b').textContent), { direction: 'top' })
            .on('click', function () { window.location.href = a.getAttribute('href'); })
            .addTo(map);
        });
      });
    });
  }

  function init() {
    majEtat();
    setInterval(majEtat, 60000);
    document.querySelectorAll('[data-sdv-etab-map]').forEach(carteEtablissement);
    document.querySelectorAll('[data-sdv-dae]').forEach(blocDae);
    document.querySelectorAll('[data-sdv-galerie]').forEach(galerie);
    document.querySelectorAll('[data-sdv-video]').forEach(video);
    document.querySelectorAll('[data-sdv-zones]').forEach(zones);
    document.querySelectorAll('[data-sdv-annuaire]').forEach(annuaire);
    document.querySelectorAll('[data-sdv-annu-map]').forEach(carteAnnuaire);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
